var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveLocationView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 56,
    viewBox: "0 0 48 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.75C25.6569 24.75 27 23.4069 27 21.75C27 20.0931 25.6569 18.75 24 18.75C22.3431 18.75 21 20.0931 21 21.75C21 23.4069 22.3431 24.75 24 24.75Z",
    stroke: "#1B1D21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21.75C31.5 28.5 24 33.75 24 33.75C24 33.75 16.5 28.5 16.5 21.75C16.5 19.7609 17.2902 17.8532 18.6967 16.4467C20.1032 15.0402 22.0109 14.25 24 14.25C25.9891 14.25 27.8968 15.0402 29.3033 16.4467C30.7098 17.8532 31.5 19.7609 31.5 21.75Z",
    stroke: "#1B1D21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.75C25.6569 24.75 27 23.4069 27 21.75C27 20.0931 25.6569 18.75 24 18.75C22.3431 18.75 21 20.0931 21 21.75C21 23.4069 22.3431 24.75 24 24.75Z",
    stroke: "#1B1D21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21.75C31.5 28.5 24 33.75 24 33.75C24 33.75 16.5 28.5 16.5 21.75C16.5 19.7609 17.2902 17.8532 18.6967 16.4467C20.1032 15.0402 22.0109 14.25 24 14.25C25.9891 14.25 27.8968 15.0402 29.3033 16.4467C30.7098 17.8532 31.5 19.7609 31.5 21.75Z",
    stroke: "#1B1D21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveLocationView);
export default __webpack_public_path__ + "static/media/live_location_view.d0cf93f1443e335356dfd0b76d591966.svg";
export { ForwardRef as ReactComponent };